import { db, requestPermission } from 'src/db'
import { firestoreAction } from 'vuexfire'

export default {
    namespaced: true,
    state: {
		userClaims: null,
		campaigns: [],
        prospects: [],
		fcmToken: '',
		convos: null,
		groupconvos: null,
		messages: [],
		grpmessages: [],
		mails: [],
		phones:[],
        user: null,
		teams:[],
		emails:null,
		calls:null,
		extensionuuid:null
    },
    mutations: {
		SET(state, payload) {
			switch (payload.var) {
				case 'fcmToken': state.fcmToken = payload.val;
				break;
				case 'userClaims': state.userClaims = payload.val;
			}
		},
		CLEAR_ALL(state) {
			state.fcmToken = '';
			state.user = null;
			state.messages = [];
			state.grpmessages = [];
			state.mails = [];
			state.phones = [];
			state.convos = null;
			state.groupconvos = null;
			state.prospects = [];
			state.campaigns = [];
			state.userClaims = null;
			state.teams = [];
			state.emails = null;
			state.calls = null;
			state.extensionuuid=null
		},
		CLEAR_MAILS(state) {
			state.mails = [];
			state.emails = null;
		},
		CLEAR_ONLY_MAILS(state) {
			state.mails = [];
		},
		CLEAR_CALLS(state) {
			state.phones = [];
			state.calls = null;
		},
		CLEAR_ONLY_PHONES(state) {
			state.phones = [];
		}
    },
    actions: {
		async fetchFcmToken(context, payload) {
			try {
				let token = await requestPermission();
				context.commit('SET', {var: 'fcmToken', val: token});
				if (!payload.user.fcmTokens) { payload.user.fcmTokens = {}; }
				if (token && payload.user.fcmTokens[token] != true) {
					payload.user.fcmTokens[token] = true;
					db.doc(`Users/${payload.id}`).set(payload.user);
				}
			} catch (err) {
				// eslint-disable-next-line
				console.error(err);
			}
		},
		setExtensionUUID : firestoreAction(({bindFirestoreRef},exid)=>{
			return bindFirestoreRef('extensionuuid',exid);
		}),
		rebindConvos: firestoreAction(({ bindFirestoreRef }, uid) => {
			let p4 = bindFirestoreRef('convos', db.collection('Conversations')
			.where('Uid', '==', uid).orderBy('DateUpdated', 'desc'));
			return Promise.all([p4]);
		}),
		rebindProspects: firestoreAction(({ bindFirestoreRef }, pid) => {
			let p2 = bindFirestoreRef('prospects', db.collection(`Users/${pid}/Prospects`));
			return Promise.all([p2]);
		}),
		rebindProspectsNew: firestoreAction(async ({ dispatch, bindFirestoreRef }, uid) => {
			return db.collection('Users').where('Uid', '==', uid).get().then(querySnap => {
				querySnap.docs[0].ref.get().then( docSnap => {
					dispatch('fetchFcmToken', {user: docSnap.data(), id: docSnap.id});
				});
				let pid = querySnap.docs[0].id;	
			
				let p2 = bindFirestoreRef('prospects', db.collection(`Users/${pid}/Prospects`));
				return Promise.all([p2]);
			})
		}),
		
		// rebindEmails: firestoreAction(({ bindFirestoreRef }, uid) => {
		// 	let p6 = bindFirestoreRef('emails', db.collection('Emails').where('Uid', '==', uid));
		// 	return Promise.all([p6]);
		// }),
		
		rebindEmails: firestoreAction(({ bindFirestoreRef }, uid) => {
			let p6 = bindFirestoreRef('emails', db.collection('Emails')
			.where('Uid', '==', uid));
			return Promise.all([p6]);
		}),

		// rebindCalls: firestoreAction(({ bindFirestoreRef }, uid) => {
		// 	let p8 = bindFirestoreRef('calls', db.collection('Calls')
		// 	.where('Uid', '==', uid));
		// 	return Promise.all([p8]);
		// }),
		// rebindCampaigns: firestoreAction(({ bindFirestoreRef }, pid) => {
		// 	return bindFirestoreRef('campaigns', db.collection(`Users/${pid}/Campaigns`));
		// }),
		
		bindMessages: firestoreAction(({ bindFirestoreRef }, convoId) => {
			return bindFirestoreRef('messages', db.collection(`Conversations/${convoId}/Messages`).orderBy('Date', 'desc'));
			// return bindFirestoreRef('messages', db.collection(`Conversations/${convoId}/Messages`).orderBy('Date', 'desc'));
		}),
		bindGroupMessages: firestoreAction(({ bindFirestoreRef }, grpconvoId) => {
			return bindFirestoreRef('grpmessages', db.collection(`Conversations_v2/${grpconvoId}/Messages`).orderBy('Date', 'desc'));

			// return bindFirestoreRef('messages', db.collection(`Conversations/${convoId}/Messages`).orderBy('Date', 'desc'));
		}),
		bindMails: firestoreAction(({ bindFirestoreRef }, mailId) => {
			let mailList = [];
			if  (mailId) {
				mailList = db.collection(`Emails/${mailId}/Mails`).orderBy('Date', 'desc').limit(100);
			}
			return bindFirestoreRef('mails', mailList);
		}),

		bindPhones: firestoreAction(({ bindFirestoreRef }, callId) => {
			let callList = [];
			if  (callId) {
				callList = db.collection(`Calls/${callId}/Phones`).orderBy('Date', 'desc').limit(100);
			}
			return bindFirestoreRef('phones', callList);
		}),


		bindUserData: firestoreAction(async ({ dispatch, bindFirestoreRef }, uid) => {
			return db.collection('Users').where('Uid', '==', uid).get().then(querySnap => {
				querySnap.docs[0].ref.get().then( docSnap => {
					dispatch('fetchFcmToken', {user: docSnap.data(), id: docSnap.id});
				});
				let pid = querySnap.docs[0].id;
				let p1 = bindFirestoreRef('user', db.doc(`Users/${pid}`));
				// let p2 = bindFirestoreRef('prospects', db.collection(`Users/${pid}/Prospects`));
				let p3 = bindFirestoreRef('campaigns', db.collection(`Users/${pid}/Campaigns`));
				//let p4 = bindFirestoreRef('convos', db.collection('Conversations')
					//.where('Uid', '==', uid).orderBy('DateUpdated', 'desc').limit(3));
				let p7 = bindFirestoreRef('groupconvos', db.collection('Conversations_v2')
					.where('Uid', '==', uid).orderBy('DateUpdated', 'desc'));
				
				let p5 = bindFirestoreRef('teams', db.doc(`Team/zzxOvpZGle9GsNlZqisB`));

				// let p6 = bindFirestoreRef('emails', db.collection('Emails').where('Uid', '==', uid).limit(3));
				let p8 = bindFirestoreRef('calls', db.collection('Calls').where('Uid', '==', uid));
				return Promise.all([p1, p3, p5, p7, p8]);
			})
		}),
		bindAdminData: firestoreAction(({ bindFirestoreRef }, uid) => {
			return db.collection('Users').where('Uid', '==', uid).get().then(querySnap => {
				let pid = querySnap.docs[0].id;
				let p1 = bindFirestoreRef('user', db.doc(`Users/${pid}`));
				let p2 = bindFirestoreRef('convos', db.collection('Conversations')
					.orderBy('DateUpdated', 'desc').limit(100));

				// let p3 = bindFirestoreRef('emails', db.collection('Emails')
				// 	.orderBy('DateUpdated', 'desc').limit(100));
				return Promise.all([p1, p2]);
			})
		}),
		clearBoundData: firestoreAction(({ commit, unbindFirestoreRef }) => {
			unbindFirestoreRef('campaigns');
			unbindFirestoreRef('prospects');
			unbindFirestoreRef('messages');
			unbindFirestoreRef('convos');
			unbindFirestoreRef('groupconvos');
			unbindFirestoreRef('user');
			unbindFirestoreRef('teams');
			unbindFirestoreRef('emails');
			unbindFirestoreRef('calls');
			unbindFirestoreRef('mails');
			unbindFirestoreRef('phones');
			unbindFirestoreRef('grpmessages');
			commit('CLEAR_ALL');
		}),
		clearMailsData: firestoreAction(({ commit, unbindFirestoreRef }) => {
			
			unbindFirestoreRef('emails');
			unbindFirestoreRef('mails');
			commit('CLEAR_MAILS');
		}),
		
		clearonlyMailsData: firestoreAction(({ commit, unbindFirestoreRef }) => {
			unbindFirestoreRef('mails');
			commit('CLEAR_ONLY_MAILS');
		}),

		clearCallsData: firestoreAction(({ commit, unbindFirestoreRef }) => {
			unbindFirestoreRef('calls');
			unbindFirestoreRef('phones');
			commit('CLEAR_CALLS');
		}),
		
		clearonlyPhonesData: firestoreAction(({ commit, unbindFirestoreRef }) => {
			unbindFirestoreRef('phones');
			commit('CLEAR_ONLY_PHONES');
		})
	}
}
